

<template>
  <div class="h-screen">
    <div class="pb-10">
      <div
      class="
        text-[#505050]
        p-2
        text-center
        font-bold
        text-3xl
        font-sans
        border-b-8 border-gray-800
      "
    >
      Bank Financing Requirements
    </div>
    <div class="my-2 mt-2">
      <h2 class="font-bold">{{ ulTitle }}</h2>
    </div>
    <!-- <CheckList :ulListCheck="list" /> -->
    <div>
      <ul>
        <li class="flex items-center">
          <img
            src="../../../../../assets/icons/check.png"
            class="mr-4 w-[16px]"
            alt=""
          />
          The down payment must be fully paid
        </li>
        <li class="flex items-center">
          <img
            src="../../../../../assets/icons/check.png"
            class="mr-4 w-[16px]"
            alt=""
          />

          The Registration Fee / Title Transfer Fee must be fully paid based on
          the prevailing rate
        </li>
        <li class="flex items-center">
          <img
            src="../../../../../assets/icons/check.png"
            class="mr-4 w-[16px]"
            alt=""
          />
          Settle the updated Real Property Tax
        </li>
        <li class="flex items-center">
          <img
            src="../../../../../assets/icons/check.png"
            class="mr-4 w-[16px]"
            alt=""
          />
          The loan difference, if any, must be settled
        </li>
        <li class="flex items-center">
          <img
            src="../../../../../assets/icons/check.png"
            class="mr-4 w-[16px]"
            alt=""
          />
          Moldex will need to receive the loan proceeds
        </li>
      </ul>
    </div>
    <hr class="bg-gray-900 my-6" />
    <div>
      <div class="font-bold">
        Documentary requirements to initiate the title transfer:
      </div>

      <div class="my-2">
        <ul>
          <li class="flex items-center">A. Individual</li>
          <li class="flex items-center">
            <img
              src="../../../../../assets/icons/check.png"
              class="mr-4 w-[16px]"
              alt=""
            />
            Accomplished Buyers Information Sheet signed by both spouses, if
            applicable
          </li>

          <li class="flex items-center">
            <div>
              <img
                src="../../../../../assets/icons/check.png"
                class="mr-4 w-[16px]"
                alt=""
              />
            </div>
            <div>
              1 valid primary government issued ID (ex. TIN, UMID, Passport,
              SSS, Driver’s License, Postal ID)
            </div>
          </li>

          <li class="flex items-center">
            <img
              src="../../../../../assets/icons/check.png"
              class="mr-4 w-[16px]"
              alt=""
            />
            Birth Certificate if single; Marriage Contract if married
          </li>

          <li class="flex items-center">
            <img
              src="../../../../../assets/icons/check.png"
              class="mr-4 w-[16px]"
              alt=""
            />
            BIR 1904 Form Verified by BIR of both spouses, if applicable
          </li>
          <li>
            <div class="px-8 my-4">
              Note: All documents submitted will undergo evaluation. Further
              documents may be required.
            </div>
          </li>
        </ul>
      </div>

      <ul class="my-4">
        <li class="flex items-center">B. Company</li>
        <li class="flex items-center">
          <img
            src="../../../../../assets/icons/check.png"
            class="mr-4 w-[16px]"
            alt=""
          />
          Certificate of Incorporation
        </li>

        <li class="flex items-center">
          <img
            src="../../../../../assets/icons/check.png"
            class="mr-4 w-[16px]"
            alt=""
          />
          Certificate of Registration
        </li>

        <li class="flex items-center">
          <img
            src="../../../../../assets/icons/check.png"
            class="mr-4 w-[16px]"
            alt=""
          />
          Secretary Certificate / Board Resolution
        </li>

        <li class="flex items-center">
          <img
            src="../../../../../assets/icons/check.png"
            class="mr-4 w-[16px]"
            alt=""
          />
          Articles of Incorporation and By-Laws
        </li>

        <li class="flex items-center">
          <img
            src="../../../../../assets/icons/check.png"
            class="mr-4 w-[16px]"
            alt=""
          />
          TIN Verified of company
        </li>

        <li class="flex items-center">
          <img
            src="../../../../../assets/icons/check.png"
            class="mr-4 w-[16px]"
            alt=""
          />
          TIN Verified of authorized signatory
        </li>

        <li class="flex items-center">
          <img
            src="../../../../../assets/icons/check.png"
            class="mr-4 w-[16px]"
            alt=""
          />
          2 valid government issued IDs of signatory
        </li>
        <li>
          <div class="my-2 px-8 my-4">
            Note: Once you've completed the payments and requirements, you will
            be contacted to schedule the signing the Deed of Absolute Sale at
            our head office.
          </div>
        </li>
      </ul>
    </div>
    </div>
  </div>
</template>

<script>
// import CheckList from "../../components/CheckList.vue";
// import HeaderBar from "../../components/HeaderBar.vue";
export default {
  data() {
    return {
      ulTitle: " Monetary requirements to initiate the title transfer:",
    };
  },
  // components: { HeaderBar },
  props: ["hTitle"],
};
</script>